import React from 'react';
import PropTypes from 'prop-types';

const CustomPageTitle = (props) => {

  let {
    pageTitle,
    pageSubTitle,
    pageImageUrl,
  } = props;

  let style = {};
  if (pageImageUrl && pageImageUrl.trim().length > 0) {
    style = {
      backgroundImage: `url(${pageImageUrl})`,
    }
  }

  return (
    <>
      {
      <div className="m_topicsHead"  style={style}>
        <div className="inner">
          <h1 className="head">{pageTitle}</h1>
          <p className="subText">{pageSubTitle}</p>
        </div>
      </div>
      }
    </>
  );
};

CustomPageTitle.propTypes = {
  pageTitle: PropTypes.any.isRequired,
  pageSubTitle: PropTypes.string,
  pageImageUrl: PropTypes.string
};

export default CustomPageTitle;
